import { css } from '@emotion/css';
import { InfoOutlineIcon } from '../../shared/assets/icons';
import { Colors } from '../../shared/styles/colors';
import { p2Style } from '../../shared/styles/text';
import { Radius } from '../../shared/styles/tokens';

export const WalletInfo = (): JSX.Element => {
  return (
    <div className={infoOuterRootStyle}>
      <InfoOutlineIcon className={iconStyle} aria-hidden="true" />
      <p className={p2Style}>
        You can also add funds at the front desk using cash or card.
      </p>
    </div>
  );
};

const infoOuterRootStyle = css`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-top: 1.5rem;
  padding: 0.875rem 1rem;
  background: ${Colors.CAPRI_BLUE_TINT};
  border-radius: ${Radius.md};

  > p {
    color: ${Colors.INK};
  }
`;

const iconStyle = css`
  flex: 0 0 auto;
  margin-top: 0.0625rem;
`;
